import clsx from 'clsx'
import {Fragment, useContext, useEffect, useState} from 'react'
import {Badge, Stack} from 'react-bootstrap'
import {ModernPagination} from 'src/app/shared/ModernPagination'
import {KTCardBody, KTIcon} from '../../../../../_metronic/helpers'
import {getAllGrupoAprobaciónsPag} from '../../../../services/grupoAprobacion'
import {activarRol, deleteRol} from '../../../../services/rol'
import {showDeleteMessage, showMessage, showReactivationMessage} from '../../../../shared/Alerts'
import {UsersListLoading} from '../../../apps/user-management/users-list/components/loading/UsersListLoading'
import {PartnerContext} from '../PartnerContexts'

const GrupoAprobacionTable = () => {
  const [isLoading, setLoadingStatus] = useState(false)
  const [lista, setLista] = useState([])
  const {
    searchTerm,
    setGrupoAprobacionData,
    setEditOpenShowModal,
    reloadTable,
    setReloadTable,
    currentPage,
    setCurrentPage,
    totalPages,
    setTotalPages,
  } = useContext(PartnerContext)

  useEffect(() => {
    setLoadingStatus(true)
    refetchData({
      searchQuery: searchTerm,
    })
  }, [])

  useEffect(() => {
    setLoadingStatus(true)
    refetchData({
      searchQuery: searchTerm,
    })
  }, [searchTerm, currentPage])

  useEffect(() => {
    setLoadingStatus(true)
    if (reloadTable) {
      refetchData({
        searchQuery: searchTerm,
      })
      setReloadTable(false)
    }
  }, [reloadTable])

  const refetchData = (options: any) => {
    setLoadingStatus(true)
    getAllGrupoAprobaciónsPag(currentPage, 10, options)
      .then((response) => {
        if (response.success) {
          console.log(response)
          setLoadingStatus(false)
          const auxTotalPage = response.length ? Math.ceil(response.length / 10) : totalPages
          setTotalPages(auxTotalPage)
          setLista(response?.data)
        } else {
          console.log(response)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const handleDelete = (id: string) => {
    showDeleteMessage().then((result) => {
      if (result.isConfirmed) {
        deleteRol(id)
          .then((response) => {
            if (response.success) {
              console.log(response)
              showMessage('success', '¡Buen trabajo!', response.message)
            } else {
              console.log(response)
              showMessage('error', 'Hubo un error', response.error)
            }
            refetchData({
              searchQuery: searchTerm,
            })
          })
          .catch((error) => showMessage('error', 'Hubo un error', error.message))
      }
    })
  }

  const handleReactivation = (id: string) => {
    showReactivationMessage().then((result) => {
      if (result.isConfirmed) {
        activarRol(id)
          .then((response) => {
            if (response.success) {
              console.log(response)
              showMessage('success', '¡Buen trabajo!', response.message)
            } else {
              console.log(response)
              showMessage('error', 'Hubo un error', response.error)
            }
            refetchData({
              searchQuery: searchTerm,
            })
          })
          .catch((error) => showMessage('error', 'Hubo un error', error.message))
      }
    })
  }

  const handleActualizar = (item: any) => {
    setEditOpenShowModal(true)
    setGrupoAprobacionData(item)
  }

  return (
    <>
      <KTCardBody className='py-4 min-vh-100'>
        <div className='table-responsive min-vh-100'>
          <table className='table align-middle table-row-bordered fs-6 table-hover'>
            <thead>
              <tr className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-primary text-white'>
                <th className='text-start p-3'>Nombre</th>
                <th className='text-start'>Descripcion</th>
                <th className='text-start'>Fecha de creacion</th>
                <th className='text-start'>Cantidad de miembros</th>
                <th className='text-start'>Estado</th>
                <th className='text-end p-3'>Opciones</th>
              </tr>
            </thead>
            <tbody className='text-gray-600 fw-bold'>
              {lista.length > 0 ? (
                lista?.map((item: any, index: any) => (
                  <Fragment key={item._id}>
                    <tr>
                      <td className='text-start min-w-100px' style={{paddingLeft: '1rem'}}>
                        {item.nombre}
                      </td>
                      <td className='text-start min-w-100px'>{item.descripcion}</td>
                      <td className='text-start min-w-100px'>
                        {new Date(item.createdAt).toLocaleDateString('es-ES')}
                      </td>

                      <td className='text-start min-w-100px'>{item?.responsables?.length ?? 0}</td>
                      <td className='text-start min-w-100px'>
                        <Badge
                          className={clsx('text-white', item.estado ? 'bg-success' : 'bg-danger')}
                          pill
                        >
                          {item.estado ? 'Activo' : 'Inactivo'}
                        </Badge>
                      </td>
                      <td className='text-end d-flex align-self-end justify-content-end p-0'>
                        <Stack direction='horizontal' gap={1}>
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            title='Editar'
                            onClick={() => handleActualizar(item)}
                          >
                            <KTIcon iconName='pencil' className='fs-3' />
                          </button>
                          {item.estado ? (
                            <button
                              className='btn btn-icon btn-bg-light btn-light-danger btn-sm'
                              title='Eliminar'
                              onClick={() => handleDelete(item._id)}
                            >
                              <KTIcon iconName='cross' className='fs-3' />
                            </button>
                          ) : (
                            <button
                              className='btn btn-icon btn-bg-light btn-light-success btn-sm'
                              title='Activar'
                              onClick={() => handleReactivation(item._id)}
                            >
                              <KTIcon iconName='check' className='fs-3' />
                            </button>
                          )}
                        </Stack>
                      </td>
                    </tr>
                  </Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      No matching records found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <ModernPagination
          currentPage={currentPage}
          totalPages={totalPages}
          isLoading={isLoading}
          onPageChange={handlePageChange}
        />
        {isLoading && <UsersListLoading />}
      </KTCardBody>
    </>
  )
}

export {GrupoAprobacionTable}
